interface FooterProps {
    hasSidebar?: boolean;
}

const Footer = ({ hasSidebar }: FooterProps) => {
    return (
        <footer
            className={`w-full bg-[#9C9C9A] h-16 text-center flex justify-center items-center mt-auto shadow-inner 
      ${hasSidebar ? "lg:ml-64 lg:w-[calc(100%-16rem)] shadow-[inset_6px_0_8px_-6px_rgba(0,0,0,0.3)]" : ""}`}
        >
            <div className="m-4">
                <span className="text-sm text-white">
                    © 2025 - SAAF. Hecho por ForIT Software Factory
                </span>
            </div>
        </footer>
    );
};

export default Footer;
